// Minimal client-side CSV export. Rows is an array of plain objects; the keys of
// the first row become the header. A UTF-8 BOM is prepended so Excel renders
// Hebrew (and other non-ASCII) correctly.

function escapeCell(value) {
  if (value === null || value === undefined) return ''
  const s = String(value)
  return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
}

export function exportCsv(rows, filename = 'export.csv') {
  if (!rows || !rows.length) return
  const headers = Object.keys(rows[0])
  const lines = [
    headers.map(escapeCell).join(','),
    ...rows.map(row => headers.map(h => escapeCell(row[h])).join(',')),
  ]
  const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' })
  const url  = URL.createObjectURL(blob)
  const a    = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

// Seconds → "Hh Mm" style decimal hours (2 dp), e.g. 5400 -> 1.5
export function secondsToHours(seconds) {
  return Math.round(((seconds || 0) / 3600) * 100) / 100
}
